import { Controller, useFormContext } from 'react-hook-form';
import styles from '../index.module.scss';
import { add, getDate } from '../../../../../../../../services/timeService';
import { unitOfTime, dateTimeFormat } from '../../../../../../../../services/timeService/types';
import classNames from 'classnames';
import { FormControl } from '@mui/material';
import CustomDatePicker from '../../../../../../../CustomDatePicker';
import { isEmpty } from 'lodash';

export const DischargeField = () => {
  const {
    register,
    formState: { errors },
    control,
  } = useFormContext();

  return (
    <FormControl
      error={!!errors?.expectedDischarge}
      className={classNames({
        [styles.error]: errors?.expectedDischarge,
      })}>
      <Controller
        render={({ field }) => (
          <CustomDatePicker
            label="Expected discharge date"
            {...register('expectedDischarge', {
              setValueAs: (value) => (isEmpty(value) ? null : value),
            })}
            minDate={getDate(add(unitOfTime.day, 1))}
            showDaysOutsideCurrentMonth={true}
            onChange={(date) => {
              field.onChange(date?.format(dateTimeFormat.SERVER_DATE_FORMAT));
            }}
            isError={!!errors?.expectedDischarge}
            helperText={errors?.expectedDischarge?.message as string}
            labelClassName={styles.inTakeLabel}
          />
        )}
        name="expectedDischarge"
        control={control}
      />
    </FormControl>
  );
};
